<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> EMISSÃO DE FATURA REEMBOLSO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form
        ref="form"
        class="compact-form"
        v-model="valid"
        :lazy-validation="lazy"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="parcels"
                v-model="parcel"
                label="Nº Parcelas"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                label="Data Primeira Parcela"
                v-mask="dateMask"
                outlined
                dense
                hide-details
                v-model="fisrt_parcel"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handleClickCalendar('fisrt_parcel', null)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                label="Intervalo entre Parcelas"
                outlined
                dense
                hide-details
                v-model="interval"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-checkbox
                v-model="retification"
                :false-value="0"
                :true-value="1"
                hide-details
                label="Retificação"
                class="mt-1"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="getCompanies"
              >
                <v-icon left> mdi-plus </v-icon>
                Carregar Franqueados
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold"
                  dense
                  outlined
                  height="28"
                  dark
                  >FATURAMENTO</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="350">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-no-wrap"></th>
                              <th class="text-left text-no-wrap" width="60px">
                                Filial
                              </th>
                              <th class="text-left" width="250px">
                                Franqueado
                              </th>
                              <th class="text-left text-no-wrap" width="120px">
                                (R$) Total
                              </th>
                              <th class="text-left text-no-wrap" width="50px">
                                Parcelas
                              </th>
                              <th class="text-left text-no-wrap" width="120px">
                                (R$) Parcela
                              </th>
                              <th class="text-left text-no-wrap" width="110px">
                                Data 1
                              </th>
                              <th class="text-left text-no-wrap" width="110px">
                                Data 2
                              </th>
                              <th class="text-left text-no-wrap" width="110px">
                                Data 3
                              </th>
                              <th class="text-left text-no-wrap" width="110px">
                                Data 4
                              </th>
                              <th class="text-left text-no-wrap" width="110px">
                                Data 5
                              </th>
                              <th class="text-left text-no-wrap" width="110px">
                                Data 6
                              </th>
                              <th class="text-left text-no-wrap" width="50px">
                                Deletar
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(company, index) in companies"
                              :key="company.company_id"
                            >
                              <td>{{ ++index }}</td>
                              <td>{{ company.code }}</td>
                              <td>{{ company.name }}</td>
                              <td class="text-right">
                                {{ formatCurrency(company.value) }}
                              </td>
                              <td>
                                <v-select
                                  :items="parcels"
                                  v-model="company.parcels"
                                  @change="handleChangeParcel(company)"
                                  label=""
                                  hide-details
                                  dense
                                  outlined
                                  class="fs-12"
                                ></v-select>
                              </td>
                              <td class="text-right">
                                {{ formatCurrency(company.parcel_value) }}
                              </td>
                              <td>
                                <v-text-field
                                  v-if="company.date1 !== ''"
                                  v-mask="dateMask"
                                  label=""
                                  outlined
                                  dense
                                  hide-details
                                  class="fs-12"
                                  v-model="company.date1"
                                  style="min-width: 145px"
                                  append-outer-icon="mdi-calendar"
                                  @click:append-outer="
                                    handleClickCalendar('date1', company)
                                  "
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-if="company.date2 !== ''"
                                  v-mask="dateMask"
                                  label=""
                                  outlined
                                  dense
                                  hide-details
                                  class="fs-12"
                                  v-model="company.date2"
                                  style="min-width: 145px"
                                  append-outer-icon="mdi-calendar"
                                  @click:append-outer="
                                    handleClickCalendar('date2', company)
                                  "
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-if="company.date3 !== ''"
                                  v-mask="dateMask"
                                  label=""
                                  outlined
                                  dense
                                  hide-details
                                  class="fs-12"
                                  v-model="company.date3"
                                  style="min-width: 145px"
                                  append-outer-icon="mdi-calendar"
                                  @click:append-outer="
                                    handleClickCalendar('date3', company)
                                  "
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-if="company.date4 !== ''"
                                  v-mask="dateMask"
                                  label=""
                                  outlined
                                  dense
                                  hide-details
                                  class="fs-12"
                                  v-model="company.date4"
                                  style="min-width: 145px"
                                  append-outer-icon="mdi-calendar"
                                  @click:append-outer="
                                    handleClickCalendar('date4', company)
                                  "
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-if="company.date5 !== ''"
                                  v-mask="dateMask"
                                  label=""
                                  outlined
                                  dense
                                  hide-details
                                  class="fs-12"
                                  v-model="company.date5"
                                  style="min-width: 145px"
                                  append-outer-icon="mdi-calendar"
                                  @click:append-outer="
                                    handleClickCalendar('date5', company)
                                  "
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-if="company.date6 !== ''"
                                  v-mask="dateMask"
                                  label=""
                                  outlined
                                  dense
                                  hide-details
                                  class="fs-12"
                                  v-model="company.date6"
                                  style="min-width: 145px"
                                  append-outer-icon="mdi-calendar"
                                  @click:append-outer="
                                    handleClickCalendar('date6', company)
                                  "
                                ></v-text-field>
                              </td>
                              <td>
                                <v-tooltip top color="error">
                                  <!-- eslint-disable-next-line -->
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="red darken-1"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="deleteItem(company)"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                  <span>Deletar</span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="companies.length > 0">
                            <tr>
                              <th colspan="13">
                                Total de Franqueados: {{ companies.length }}
                              </th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    dark
                    color="green darken-3"
                    class="float-right"
                    small
                    @click="validate"
                  >
                    <v-icon left> mdi-check </v-icon>
                    Gravar Documento de Faturamento
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

import AwesomeMask from "awesome-mask";

export default {
  components: { Alert },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    parcels: [1, 2, 3, 4, 5, 6],
    parcel: 1,
    fisrt_parcel: "",
    interval: "",
    retification: 0,
    companies: [],
    companies_providers: [],
    company: "",
    provider: "",
    loading: false,
    lazy: false,
    valid: true,
    showAlert: false,
    messageAlert: "Emissão fatura de Reembolso com Sucesso",
    typeAlert: "success",
    modalDate: false,
    dateDialog: "",
    objDateDialog: {},
    fieldDateDialog: "",
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {},
    validate() {
      this.showAlert = false;
      if (this.companies.length === 0) {
        this.showAlert = true;
        this.typeAlert = "error";
        this.messageAlert =
          "É necessário ter pelo menos uma empresa no faturamento para poder gravar";
        return false;
      }
      this.saveRefund();
    },
    async getCompanies() {
      if (this.fisrt_parcel == "" || this.interval == "") {
        this.showAlert = true;
        this.typeAlert = "error";
        this.messageAlert =
          "É necessário preencher todos os campos para continuar";
        return false;
      }
      this.loading = true;
      this.showAlert = false;
      this.companies = [];
      try {
        let data = {};
        data.month = this.month;
        data.year = this.year;
        data.parcels = this.parcel;
        data.date_first_parcel = this.dateFormatToEua(this.fisrt_parcel);
        data.interval = parseInt(this.interval);
        data.retification = this.retification;

        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}refund/make`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let res = await response.json();
        if (res.length == 0) {
          this.showAlert = true;
          this.typeAlert = "warning";
          this.messageAlert = "Não existem Eventos para serem cobrados";
        } else {
          this.companies = res
            .sort((a, b) => (a.code > b.code ? 1 : -1))
            .map((item) => ({
              ...item,
              date1: this.dateFormatToBr(item.date1),
              date2: this.dateFormatToBr(item.date2),
              date3: this.dateFormatToBr(item.date3),
              date4: this.dateFormatToBr(item.date4),
              date5: this.dateFormatToBr(item.date5),
              date6: this.dateFormatToBr(item.date6),
            }));
        }
      } catch (error) {
        this.showAlert = true;
        this.typeAlert = "error";
        this.messageAlert = error.message;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    dateFormatToBr(date) {
      if (date == "") return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "") return "";
      return date.split("/").reverse().join("-");
    },
    handleChangeParcel(item) {
      let [day, month, year] = this.fisrt_parcel.split("/");
      let date1 = new Date(year, month - 1, day);
      let date2 = new Date(date1);
      let date3 = new Date(date1);
      let date4 = new Date(date1);
      let date5 = new Date(date1);
      let date6 = new Date(date1);

      date2.setDate(date2.getDate() + parseInt(this.interval));
      date3.setDate(date3.getDate() + this.interval * 2);
      date4.setDate(date4.getDate() + this.interval * 3);
      date5.setDate(date5.getDate() + this.interval * 4);
      date6.setDate(date6.getDate() + this.interval * 5);

      item.date2 =
        item.parcels >= 2 ? `${date2.toLocaleDateString("pt-BR")}` : "";
      item.date3 =
        item.parcels >= 3 ? `${date3.toLocaleDateString("pt-BR")}` : "";
      item.date4 =
        item.parcels >= 4 ? `${date4.toLocaleDateString("pt-BR")}` : "";
      item.date5 =
        item.parcels >= 5 ? `${date5.toLocaleDateString("pt-BR")}` : "";
      item.date6 =
        item.parcels >= 6 ? `${date6.toLocaleDateString("pt-BR")}` : "";

      let value = parseFloat(item.value);
      let parcel_value = (value / item.parcels).toFixed(2);
      item.parcel_value = parcel_value;
    },
    deleteItem(item) {
      let copyCompanies = [...this.companies];
      let index = copyCompanies.findIndex(
        (i) => i.company_id === item.company_id
      );
      copyCompanies.splice(index, 1);
      this.companies = [...copyCompanies];
    },
    async saveRefund() {
      let data = {
        month: this.month,
        year: this.year,
        parcel: this.parcel,
        date_first_parcel: this.dateFormatToEua(this.fisrt_parcel),
        interval: parseInt(this.interval),
        retification: this.retification,
        companies: this.companies.map((company) => ({
          ...company,
          date1: this.dateFormatToEua(company.date1),
          date2: this.dateFormatToEua(company.date2),
          date3: this.dateFormatToEua(company.date3),
          date4: this.dateFormatToEua(company.date4),
          date5: this.dateFormatToEua(company.date5),
          date6: this.dateFormatToEua(company.date6),
        })),
      };
      console.log(data);
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}refund`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        console.log(response);
        this.clearAll();
        this.showAlert = true;
        this.typeAlert = "success";
        this.messageAlert = "Fatura de Reembolso Criada com Sucesso";
      } catch (error) {
        this.showAlert = true;
        this.typeAlert = "error";
        this.messageAlert = error.message;
      } finally {
        this.loading = false;
      }
    },
    clearAll() {
      let dateNow = new Date();
      this.month = dateNow.getMonth() + 1;
      this.year = dateNow.getFullYear();
      this.parcel = 1;
      this.fisrt_parcel = "";
      this.interval = "";
      this.retification = 0;
      this.companies = [];
      this.modalDate = false;
      this.dateDialog = "";
      this.objDateDialog = {};
      this.fieldDateDialog = "";
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
      }).format(value);
    },
    handleClickCalendar(field, obj) {
      let date = obj === null ? this[field] : obj[field];
      this.objDateDialog = obj;
      this.fieldDateDialog = field;
      this.dateDialog = this.dateFormatToEua(date);
      this.modalDate = true;
    },
    handlePickerDate() {
      this.modalDate = false;
      if (this.objDateDialog === null) {
        this[this.fieldDateDialog] = this.dateFormatToBr(this.dateDialog);
      } else {
        this.objDateDialog[this.fieldDateDialog] = this.dateFormatToBr(
          this.dateDialog
        );
        let companyCopies = [...this.companies];
        let companySelectedIndex = companyCopies.findIndex(
          (item) => item.company_id === this.objDateDialog.company_id
        );
        companyCopies[companySelectedIndex] = { ...this.objDateDialog };
        this.companies = [...companyCopies];
      }

      this.dateDialog = "";
      this.objDateDialog = {};
      this.fieldDateDialog = "";
      // let agreement = { ...this.editedAgreement };
      // if (this.dateDialogType === "start") {
      //   agreement.start_date = this.dateToBr(this.dateDialog);
      // } else {
      //   agreement.end_date = this.dateToBr(this.dateDialog);
      // }
      // let copyAgreementsCompany = [...this.agreementsCompany];
      // let index = copyAgreementsCompany.findIndex(
      //   (item) => item.id === agreement.id
      // );
      // copyAgreementsCompany[index] = { ...agreement };
      // this.agreementsCompany = [...copyAgreementsCompany];
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 12.5px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
.compact-form .fs-12 {
  transform: scale(0.75);
  transform-origin: left;
}
</style>
